// Brand ID
export const BRAND_ID = "64abf0a42f180df74476b6f0";

// Product Colors
export const ProductColors = [
  "Red",
  "Blue",
  "Cyan",
  "Green",
  "Yellow",
  "Violet",
  "Black",
  "White",
];

// Product Sizes
export const ProductSizes = ["Small", "Medium", "Large", "One Size"];

export const HowManyColorsUsed = [0, 1, 2, 3, 4];
